// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"ecdb1afb","447":"72d43af3","731":"1a6df288","787":"36ba2034","894":"c1112121"}[chunkId] + ".chunk.js";
};